module.exports = __webpack_public_path__ + "img/phone-blue.4c401f75.svg";